import { render, staticRenderFns } from "./HostingRepresentativeMyResources.vue?vue&type=template&id=7be9f4c6&scoped=true"
import script from "./HostingRepresentativeMyResources.vue?vue&type=script&lang=js"
export * from "./HostingRepresentativeMyResources.vue?vue&type=script&lang=js"
import style0 from "./HostingRepresentativeMyResources.vue?vue&type=style&index=0&id=7be9f4c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be9f4c6",
  null
  
)

export default component.exports